module.exports = __webpack_public_path__ + "img/upimg.41b8c028.png";